module.exports = __webpack_public_path__ + "img/teaser.4989e112.jpg";